import type { SmriqOperationExclusion } from '../types/smriq.types';

// Order-independent identity of a decline set, so a toggle undone within the debounce window
// (net no change) skips the regenerate rather than re-pricing the plan already on screen.
export function smriqExclusionsKey(list: readonly SmriqOperationExclusion[]): string {
    // Encoded structurally, as the basket-pricing key is: both vendor ids are opaque and may
    // contain the separator, so a joined pair would not identify exactly one pair.
    return JSON.stringify(
        list
            .map((exclusion) => JSON.stringify([exclusion.service_id, exclusion.operation_id]))
            .sort()
    );
}
